import download from "downloadjs";
import React from "react";
import { useReducer, useState } from "react"
import { Button, Dropdown, Form, Modal, Spinner, Tab, Tabs } from "react-bootstrap"
import { BiPlusCircle } from "react-icons/bi";
import api from "../../../../services/api";
import { ResultReportRequest } from "../../../../services/Service";
import ButtonDelete from "../../../helper/ButtonDelete";
import StringInput from "../../../helper/StringInput";
import { StrValidation } from "../../../helper/StringValidation";
import { Project } from "../../model";
import { ResultModel } from "../../results";

interface ResultReportModalProps {
    show: boolean
    project: Project
    result: ResultModel
    onCancel: () => void
}

const ResultReportModal = ({ show, project, result, onCancel }: ResultReportModalProps) => {
    const initialState = {
        isClientProposal: true,
        //Client Proposal
        clientName: '',
        clientTitle: '',
        projectAddress: project.location.address,
        userName: '',
        userTitle: '',
        userEmail: '',
        userPhone: '',
        companyName: '',
        companyDescription: '',
        companyLogo: '',
        customerTestimonials: [{body: 'Write a nice testimonial here', signature: 'Bob from Accounting - UL'}],
        //Engineer Detail
        projectDescription: project.notes,
        customLogo: '',
        paperSize: 'A4',
    }
    const [showError, setShowError] = useState(false)
    const [state, dispatch] = useReducer(loginReducer, initialState);
    const { isClientProposal,
        clientName,
        clientTitle,
        projectAddress,
        userName,
        userTitle,
        userEmail,
        userPhone,
        companyName,
        companyDescription,
        customerTestimonials,
        projectDescription,
        paperSize
    } = state;
    //useEffect(() => { setDescription('') }, [show])
    const [companyLogo, setCompanyLogo] = useState('')
    const [companyLogoError, setCompanyLogoError] = useState('')
    const [customLogo, setCustomLogo] = useState('')
    const [customLogoError, setCustomLogoError] = useState('')
    const [showReportError, setShowReportError] = useState(false)
    const [showSpinner, setShowSpinner] = useState(false)

    const getBase64 = (file: File) => {
        return new Promise(resolve => {
            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                var baseURL = reader.result;
                if (typeof baseURL !== 'string') {
                    if (isClientProposal)
                        setCompanyLogoError('Please select an image file');
                    else
                        setCustomLogoError('Please select an image file');
                }
                else {
                    if (isClientProposal) {
                        setCompanyLogo(baseURL);
                        setCompanyLogoError('');
                    }
                    else {
                        setCustomLogo(baseURL);
                        setCustomLogoError('');
                    }
                }
                resolve(baseURL);
            };
        });
    };

    const handleFileInput = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files ? event.target.files[0] : null;
        if (file) {
            if (!file.type.startsWith('image/')) {
                setCompanyLogoError('Please select an image file');
                return false
            } else if (file.size > 1000000) {
                setCompanyLogoError('File size is too large');

            } else {
                getBase64(file)
            }
        }
    };

    const handleConfirm = async () => {
        if (showReportError)
            setShowReportError(false)
        setShowSpinner(true)
        let id = project.id
        let request: ResultReportRequest = { isClientProposal, clientName, clientTitle, projectAddress, userName, userTitle, userEmail, userPhone, companyName, companyDescription, companyLogo, customerTestimonials, projectDescription, customLogo, paperSize }
        var sensitivity = -1
        var optimization = -1
        if (result.selection.kind == 'optimization') {
            sensitivity = result.selection.sensitivity
            optimization = result.selection.optimization
        }
        var reportResponse = await api.downloadReportFile(id, result.resultId, sensitivity, optimization, request)
        if (reportResponse.succeded == false)
            setShowReportError(true)
        else {
            onCancelReport()
            download(reportResponse.data!, reportResponse.fileName, 'application/octet-stream')
        }
        setShowSpinner(false)
    }

    const onCancelReport = () => {
        if (showReportError)
            setShowReportError(false)
        if (showSpinner)
            setShowSpinner(false)
        onCancel()
    }

    return (
        <Modal show={show} onHide={() => onCancelReport()} size='lg'>
            <Modal.Header closeButton onHide={() => onCancelReport()}>
                <Modal.Title>Generate Proposal</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className='d-flex flex-column container-fluid bg-white rounded-lg mt-0 justify-content-center'>
                    <Tabs
                        defaultActiveKey="projectInfo"
                        id="resultReportProjectInfo"
                        className="mb-3 mt-2"
                        variant="pills">
                        <Tab eventKey="projectInfo" title="Project Info" className="m-2">
                            {/*<div className='form-group row align-items-center'>*/}
                            {/*    <div className='col-3'>*/}
                            {/*        <Form.Check custom label='Client Proposal' id='clientPorposalRadio' type='radio'*/}
                            {/*            checked={isClientProposal}*/}
                            {/*            onChange={ev => { dispatch({ type: 'field', fieldName: 'isClientProposal', payload: ev.target.checked }) }} />*/}
                            {/*    </div>*/}
                            {/*    <div className='col-3'>*/}
                            {/*        <Form.Check custom label='Engineer Detail' id='engineerDetailRadio' type='radio'*/}
                            {/*            checked={!isClientProposal}*/}
                            {/*            onChange={ev => { dispatch({ type: 'field', fieldName: 'isClientProposal', payload: !ev.target.checked }) }} />*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                            {isClientProposal && <React.Fragment>
                                <div className='form-group row align-items-center'>
                                    <label className='col-12 alert alert-danger' hidden={!showError}>Error sharing the project, please make sure the provided email is associated with a Homer Front license</label>
                                </div>
                                <div className='form-group row align-items-center'>
                                    <label className='col-12'>Client Name</label>
                                    <div className='col-12'>
                                        <input className='form-control'
                                            value={clientName} onChange={ev => dispatch({ type: 'field', fieldName: 'clientName', payload: ev.target.value })} />
                                    </div>
                                </div>
                                <div className='form-group row align-items-center'>
                                    <label className='col-12'>Client Title</label>
                                    <div className='col-12'>
                                        <input className='form-control'
                                            value={clientTitle} onChange={ev => dispatch({ type: 'field', fieldName: 'clientTitle', payload: ev.target.value })} />
                                    </div>
                                </div>
                                <div className='form-group row align-items-center'>
                                    <label className='col-12'>Project Address</label>
                                    <div className='col-12'>
                                        <input className='form-control'
                                            value={projectAddress} onChange={ev => dispatch({ type: 'field', fieldName: 'projectAddress', payload: ev.target.value })} />
                                    </div>
                                </div>
                            </React.Fragment>
                            }
                            {!isClientProposal &&
                                <div className='form-group row align-items-center'>
                                    <label className='col-12'>Project Description</label>
                                    <div className='col-12'>
                                        <textarea className='form-control'
                                            value={projectDescription} onChange={ev => dispatch({ type: 'field', fieldName: 'projectDescription', payload: ev.target.value })} />
                                    </div>
                                    {/*<label className='col-12'>Custom Logo</label>*/}
                                    {/*<div className='col-12'>*/}
                                    {/*    <input type="file" onChange={handleFileInput} />*/}
                                    {/*    {customLogoError != '' && <p style={{ color: 'red' }} >{customLogoError}</p>}*/}
                                    {/*</div>*/}
                                </div>

                            }
                        </Tab>
                        <Tab eventKey="userInfo" title="User Info" tabClassName={!isClientProposal ? 'd-none' : ''} disabled={!isClientProposal}>
                            <div className='form-group row align-items-center'>
                                <label className='col-12'>Your Name</label>
                                <div className='col-12'>
                                    <input className='form-control'
                                        value={userName} onChange={ev => dispatch({ type: 'field', fieldName: 'userName', payload: ev.target.value })} />
                                </div>
                            </div>
                            <div className='form-group row align-items-center'>
                                <label className='col-12'>Your Title</label>
                                <div className='col-12'>
                                    <input className='form-control'
                                        value={userTitle} onChange={ev => dispatch({ type: 'field', fieldName: 'userTitle', payload: ev.target.value })} />
                                </div>
                            </div>
                            <div className='form-group row align-items-center'>
                                <label className='col-12'>Your Email</label>
                                <div className='col-12'>
                                    <input className='form-control'
                                        value={userEmail} onChange={ev => dispatch({ type: 'field', fieldName: 'userEmail', payload: ev.target.value })} />
                                </div>
                            </div>
                            <div className='form-group row align-items-center'>
                                <label className='col-12'>Your Phone</label>
                                <div className='col-12'>
                                    <input className='form-control'
                                        value={userPhone} onChange={ev => dispatch({ type: 'field', fieldName: 'userPhone', payload: ev.target.value })} />
                                </div>
                            </div>
                        </Tab>
                        <Tab eventKey="companyInfo" title="Company Info" tabClassName={!isClientProposal ? 'd-none' : ''} disabled={!isClientProposal}>
                            <div className='form-group row align-items-center'>
                                <label className='col-12'>Company Name</label>
                                <div className='col-12'>
                                    <input className='form-control'
                                        value={companyName} onChange={ev => dispatch({ type: 'field', fieldName: 'companyName', payload: ev.target.value })} />
                                </div>
                            </div>
                            <div className='form-group row align-items-center'>
                                <label className='col-12'>Company Description</label>
                                <div className='col-12'>
                                    <input className='form-control'
                                        value={companyDescription} onChange={ev => dispatch({ type: 'field', fieldName: 'companyDescription', payload: ev.target.value })} />
                                </div>
                            </div>
                            {/*<div className='form-group row align-items-center'>*/}
                            {/*    <label className='col-12'>Company Logo</label>*/}
                            {/*    <div className='col-12'>*/}
                            {/*        <input type="file" onChange={handleFileInput} />*/}
                            {/*        {companyLogoError != '' && <p style={{ color: 'red' }} >{companyLogoError}</p> }*/}
                            {/*    </div>*/}
                            {/*</div>*/}
                        </Tab>
                        {/*<Tab eventKey="customerTestimonials" title="Customer Testimonials" tabClassName={!isClientProposal ? 'd-none' : ''} disabled={!isClientProposal}>*/}
                        {/*    <React.Fragment>*/}
                        {/*        <style>{*/}
                        {/*            `.alpha table,.alpha  tr,.alpha  th,.alpha  td{*/}
                        {/*         border:1px solid lightgray;*/}
                        {/*         text-align: center;*/}
                        {/*        }`*/}
                        {/*        }*/}
                        {/*        </style>*/}
                        {/*        <table className='alpha'>*/}
                        {/*            <tr className="ml-2 alpha">*/}
                        {/*                <th className='alpha'>Body</th>*/}
                        {/*                <th className='alpha'>Signature</th>*/}
                        {/*                <th className='alpha'><button className='btn btn-sm btn-outline-primary border-0' onClick={() => dispatch({ type: 'customerTestimonial', action: 'add' })}>*/}
                        {/*                    <BiPlusCircle />*/}
                        {/*                </button></th>*/}
                        {/*            </tr>*/}
                        {/*            {customerTestimonials.map((x, i) => */}
                        {/*                <tr className='alpha'>*/}
                        {/*                    <td className='alpha' key={`body-${i}`}><StringInput value={x.body}*/}
                        {/*                        onChange={ev => dispatch({ type: 'customerTestimonial', action: 'editBody', index: i, text: ev })}*/}
                        {/*                        validator={StrValidation.maxLen(400)}*/}
                        {/*                          />*/}
                        {/*                        */}{/*<textarea className='form-control'*/}
                        {/*                        */}{/*    value={x.body} onChange={ev => dispatch({ type: 'customerTestimonial', action: 'editBody', index: i, text: ev.target.value })} />*/}
                        {/*                    </td>*/}
                        {/*                    <td className='alpha' key={`signature-${i}`}>*/}
                        {/*                        <StringInput value={x.signature}*/}
                        {/*                            onChange={ev => dispatch({ type: 'customerTestimonial', action: 'editSignature', index: i, text: ev })}*/}
                        {/*                            validator={StrValidation.maxLen(400)}*/}
                        {/*                        />*/}
                        {/*                        */}{/*<textarea className='form-control'*/}
                        {/*                        */}{/*    value={x.signature} onChange={ev => dispatch({ type: 'customerTestimonial', action: 'editSignature', index: i, text: ev.target.value })} />*/}
                        {/*                    </td>*/}
                        {/*                    <td className='alpha' key={`button-${i}`}><ButtonDelete onClick={() => dispatch({ type: 'customerTestimonial', action: 'delete', index: i })} /></td>*/}
                        {/*                </tr>*/}
                        {/*            )}*/}
                        {/*        </table>*/}
                        {/*    </React.Fragment>*/}
                        {/*</Tab>*/}
                        {/*<Tab eventKey="reportSections" title="Report Sections">
                        </Tab>*/}
                        <Tab eventKey="reportFormat" title="Report Format">
                            <div className='form-group row align-items-center'>
                                <label className='col-3'>Paper Size</label>
                                <div className='col-9'>
                                    <Dropdown drop='down'>
                                        <Dropdown.Toggle variant='outline-primary'>
                                            {paperSize}
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            {paperSizes.map(v =>
                                                <Dropdown.Item key={v} onClick={() => dispatch({ type: 'field', fieldName: 'paperSize', payload: v })}>{v}</Dropdown.Item>)}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>
                            </div>
                        </Tab>
                    </Tabs>
                </div>
                {showReportError && <div className='ml-4' style={{ color: 'red' }}><p>Error generating report. Please try again later or contact support!</p></div>}
            </Modal.Body>
            <Modal.Footer>
                <Spinner hidden={!showSpinner} animation='border' size='sm' className='text-primary' />
                <Button onClick={() => onCancelReport()} variant='outline-primary'>Cancel</Button>
                <Button onClick={() => handleConfirm()}>Generate</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ResultReportModal

type testimonialAction = 'add' | 'delete' | 'editBody' | 'editSignature'

type FieldName = 'isClientProposal'
    | 'clientName'
    | 'clientTitle'
    | 'projectAddress'
    | 'userName'
    | 'userTitle'
    | 'userEmail'
    | 'userPhone'
    | 'companyName'
    | 'companyDescription'
    | 'projectDescription'
    | 'paperSize'

export interface CustomerTestimonial {
    body: string
    signature: string
}

interface ReportStateProps {
    isClientProposal: boolean
    //Client Proposal
    clientName: string
    clientTitle: string
    projectAddress: string
    userName: string
    userTitle: string
    userEmail: string
    userPhone: string
    companyName: string
    companyDescription: string
    customerTestimonials: CustomerTestimonial[]
    //Engineer Detail
    projectDescription: string
    paperSize: string
};

interface ReportActionProps {
    type: 'field' | 'customerTestimonial'
    fieldName?: FieldName
    payload?: boolean | string
    action?: testimonialAction
    index?: number
    text?: string
}


function loginReducer(state: ReportStateProps, action: ReportActionProps) {
    switch (action.type) {
        case 'field': {
            return {
                ...state,
                [action.fieldName!.toString()]: action.payload,
            };
        }
        case 'customerTestimonial': {
            switch (action.action) {
                case 'add': {
                    state.customerTestimonials.push({ body: '', signature: '' })
                    return state;
                }
                case 'delete': {
                    state.customerTestimonials.splice(action.index!, 1)
                    return state;
                }
                case 'editBody': {
                    state.customerTestimonials[action.index!].body = action.text!
                    return state;
                }
                case 'editSignature': {
                    state.customerTestimonials[action.index!].signature = action.text!
                    return state;
                }
                default:
                    return state;
            }
        }
        default:
            return state;
    }
}

const paperSizes: string[] = ['A4', 'Legal', 'Letter']

function getFileName(headers: any) {
    throw new Error("Function not implemented.");
}
